// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { arrowLeftFromLine16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-arrow-left-from-line': IconArrowLeftFromLine;
    }
}

/**
 * The icon component for the 'arrowLeftFromLine' icon
 */
export class IconArrowLeftFromLine extends Icon {
    public constructor() {
        super(arrowLeftFromLine16X16);
    }
}

registerIcon('icon-arrow-left-from-line', IconArrowLeftFromLine);
export const iconArrowLeftFromLineTag = 'nimble-icon-arrow-left-from-line';
